module.exports = __webpack_public_path__ + "static/media/codeclub.dd3ec2fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/logos/codeclub.jpg
// module id = 367
// module chunks = 0